const $ = jQuery.noConflict();

$(document).ready(function (){

  // add no-image modifier class to event cards that don't have images
  $('.event-card__image-overlay').each(function () {
    if ($(this).find('.event-card__image').attr('src') === '') {
      $(this).find('.event-card__image').remove();
      $(this).addClass('event-card--no-image');
    }
  });

});
const validateEmail = (email) => {
  const re = /^[a-z0-9.]{1,64}@[a-z0-9.]{1,64}$/i;
  return email.match(re);
};
const validateZip = (zip) => {
  const re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  return zip.match(re);
};
const emptyString = (string) => {
  return string !== '';
};
// const emailSignUpSubmit = document.getElementById('eventsListEmailFormSubmit');
const firstNameInput = document.getElementById('eventFname');
const lastNameInput = document.getElementById('eventLname');
const zipInput = document.getElementById('eventZip');
const emailInput = document.getElementById('eventEmail');
let firstNameValidated = false;
let lastNameValidated = false;
let emailValidated = false;
let zipValidated = false;
const validateFNameInput = () => {
  firstNameInput.closest('.text').classList.remove('hasError');
  firstNameValidated = true;
  if (!emptyString(firstNameInput.value)) {
    firstNameInput.closest('.text').classList.add('hasError');
    firstNameValidated = false;
  }
};
const validateLNameInput = () => {
  lastNameInput.closest('.text').classList.remove('hasError');
  lastNameValidated = true;
  if (!emptyString(lastNameInput.value)) {
    lastNameInput.closest('.text').classList.add('hasError');
    lastNameValidated = false;
  }
};
const validateZipInput = () => {
  zipInput.closest('.text').classList.remove('hasError');
  zipValidated = true;
  if (!validateZip(zipInput.value)) {
    zipInput.closest('.text').classList.add('hasError');
    zipValidated = false;
  }
};
const validateEmailInput = () => {
  emailInput.closest('.text').classList.remove('hasError');
  emailValidated = true;
  if (!validateEmail(emailInput.value)) {
    emailInput.closest('.text').classList.add('hasError');
    emailValidated = false;
  }
};
if (firstNameInput) {
  firstNameInput.addEventListener('focusout', () => {
    validateFNameInput();
  });
}
if (lastNameInput) {
  lastNameInput.addEventListener('focusout', () => {
    validateLNameInput();
  });
}
if (zipInput) {
  zipInput.addEventListener('focusout', () => {
    validateZipInput();
  });
}
if (emailInput) {
  emailInput.addEventListener('focusout', () => {
    validateEmailInput();
  });
}

if (document.querySelector('.events-list__email-form')) {
  document.querySelector('.events-list__email-form').addEventListener('submit', event => {
    if (!firstNameValidated && !lastNameValidated && !emailValidated && !zipValidated) {
      event.preventDefault();
      validateFNameInput();
      validateLNameInput();
      validateZipInput();
      validateEmailInput();
      return;
    }
    console.log('success');
  });
}